// extracted by mini-css-extract-plugin
export default {"article-date":"ArticleDate_article-date__4mV57"};